// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import * as TokenMetadata from '@digitalasset/cn-token-metadata-api-ts-client';
import React, { useContext } from 'react';

export const CNTokenMetadataApiContext = React.createContext<TokenMetadata.DefaultApi | undefined>(
  undefined,
);

export const useCNTokenMetadataApiClient = (): TokenMetadata.DefaultApi => {
  const client = useContext<TokenMetadata.DefaultApi | undefined>(CNTokenMetadataApiContext);
  if (!client) {
    throw new Error('CNTokenMetadata client not initialized');
  }
  return client;
};
